import { Hero } from '../components/Hero';
import { Button } from '../components/Button';
import { ComingSoonCard } from '../components/ComingSoonCard';
import bookCover from '../assets/NOB_KINDLE_COVER.jpg';
import './Home.css';

export function Home() {

  return (
    <div className="home">
      <Hero
        title="Notation of Being"
        subtitle="Understanding the frames we inherit — and learning how to author our own."
        size="large"
      >
        <Button to="/book" size="large">Discover the Book</Button>
      </Hero>

      <section className="home__section">
        <div className="container">
          <div className="home__book-preview">
            <div className="home__book-image">
              <img src={bookCover} alt="Notation of Being book cover" className="home__book-cover-img" />
            </div>
            <div className="home__book-content">
              <h2>The Book</h2>
              <p>
                "Notation of Being" explores how we compress reality into symbols, stories,
                and inherited frames—and what responsibility remains once we can see them clearly.
              </p>
              <p>
                Through philosophy grounded in lived experience, it offers a way to notice
                the frame—and choose how you live within it.
              </p>
              <Button to="/book">Learn More</Button>
            </div>
          </div>
        </div>
      </section>

      <section className="home__section home__section--alt">
        <div className="container">
          <h2 className="text-center">Podcast</h2>
          <ComingSoonCard
            icon="fas fa-podcast"
            title="Podcast — Coming Soon"
            description="Conversations about work, culture, belief, and everyday life—through the lens of Notation."
            subscribeAnchor="subscribe"
          />
        </div>
      </section>

      <section className="home__section">
        <div className="container">
          <h2 className="text-center">Blog</h2>
          <p className="home__section-subtitle text-center text-muted">
            Essays and reflections on everyday life—examined through frames, meaning, and authorship.
          </p>
          <div className="text-center">
            <Button to="/blog">Read the Blog</Button>
          </div>
        </div>
      </section>

      <section className="home__cta" id="subscribe">
        <div className="container text-center">
          <h2>Begin Your Journey</h2>
          <p>
            Subscribe for updates, reflections, and new releases.
          </p>
          <p className="home__cta-coming-soon">
            <i className="fas fa-envelope"></i> Email subscription coming soon
          </p>
        </div>
      </section>
    </div>
  );
}
